const PROCORE_IMAGE_HOST_PATTERN = /(^|\.)procore(?:tech|gov)?(?:-qa)?\.com$/i
const PROCORE_IMAGE_PATH_PATTERN =
  /^\/rest\/v\d+(?:\.\d+)?\/files\/\d+(?:\/[^?#\s]*)?(?:\?[^#\s]*)?$/i
const PROCORE_FAS_FILE_PATH_PATTERN =
  /^\/(?:fas\/)?api\/v\d+\/files\/[^?#\s]+$/i
const UNSAFE_PATH_PATTERN = /(?:\.\.|%2f|%5c|\\)/i

export const canonicalizeTextEditorImageUrl = (url: string) => {
  const trimmedUrl = url.trim()

  if (
    !trimmedUrl ||
    /^(?:data|javascript|vbscript|blob|file):/i.test(trimmedUrl) ||
    trimmedUrl.startsWith('//')
  ) {
    return undefined
  }

  try {
    const parsedUrl = trimmedUrl.startsWith('/')
      ? new URL(trimmedUrl, 'https://app.procore.com')
      : new URL(trimmedUrl)

    if (parsedUrl.protocol !== 'https:') {
      return undefined
    }

    const canonicalPath = `${parsedUrl.pathname}${parsedUrl.search}`

    if (UNSAFE_PATH_PATTERN.test(canonicalPath)) {
      return undefined
    }

    if (!PROCORE_IMAGE_HOST_PATTERN.test(parsedUrl.hostname)) {
      return undefined
    }

    if (PROCORE_FAS_FILE_PATH_PATTERN.test(parsedUrl.pathname)) {
      return `${parsedUrl.origin}${canonicalPath}`
    }

    if (PROCORE_IMAGE_PATH_PATTERN.test(canonicalPath)) {
      return canonicalPath
    }

    return undefined
  } catch (_error) {
    return undefined
  }
}

export const isAllowedTextEditorImageUrl = (url: string) =>
  canonicalizeTextEditorImageUrl(url) !== undefined
